export const keysByUserType = {
  admin: {
    filterKeys: [
      'owned',
      'waiting-for-you',
      'blocked',
      'pending',
      'delayed',
      'completed',
      'cancelled',
      'rejected',
      'rejected-tasks',
      'errored-tasks',
      'mine',
      'minePending',
      'mineDelayed',
      'mineCancelled',
      'mineCompleted',
      'minePaused',
      'following',
      'paused',
      'all',
      'awaiting-receipt',
    ],
    defaultFilterKey: 'owned',
  },
  regularUser: {
    filterKeys: [
      'owned',
      'waiting-for-you',
      'mine',
      'minePending',
      'mineDelayed',
      'mineCancelled',
      'mineCompleted',
      'minePaused',
      'following',
      'all',
      'awaiting-receipt',
    ],
    defaultFilterKey: 'mine',
  },
} as const

export type RequestTabAudience = keyof typeof keysByUserType

export const requestTopLevelFilterKeys = [...keysByUserType.admin.filterKeys, ...keysByUserType.regularUser.filterKeys] as const
export type RequestTopLevelFilterKey = (typeof requestTopLevelFilterKeys)[number]
